export abstract class SsoRedirectState {
  private static readonly storageKey: string = "sso-redirecting";

  public static get(): string | undefined {
    return localStorage.getItem(SsoRedirectState.storageKey) ?? undefined;
  }

  public static set(value: string) {
    localStorage.setItem(SsoRedirectState.storageKey, value);
  }

  public static clear() {
    localStorage.removeItem(SsoRedirectState.storageKey);
  }
}
